import { openLoginBox } from "./app.js";

export const FETCH_NEW_INSPECTIONS_BEGIN = "FETCH_NEW_INSPECTIONS_BEGIN";
export const FETCH_NEW_INSPECTIONS_SUCCESS = "FETCH_NEW_INSPECTIONS_SUCCESS";
export const FETCH_NEW_INSPECTIONS_ERROR = "FETCH_NEW_INSPECTIONS_ERROR";

const fetchNewInspectionsBegin = () => ({ type: FETCH_NEW_INSPECTIONS_BEGIN });

const fetchNewInspectionsSuccess = inspections => ({
	type: FETCH_NEW_INSPECTIONS_SUCCESS,
	payload: inspections
});

const fetchNewInspectionsError = error => ({
	type: FETCH_NEW_INSPECTIONS_ERROR,
	payload: { error }
});

export function fetchNewInspections() {
	return (dispatch, getState) => {
		dispatch(fetchNewInspectionsBegin());

		const s = getState();
		return fetch(
			window.INSP.config.apiUrl + "/api/inspection/getGroupedNewInspections",
			{
				method: "get",
				headers: { Authorization: "Bearer " + s.app.token }
			}
		)
			.then(r => handleErrors(r, dispatch))
			.then(res => res.json())
			.then(json => {
				dispatch(fetchNewInspectionsSuccess(json));
				return json;
			})
			.catch(error => dispatch(fetchNewInspectionsError(error)));
	};
}

export function activateInspection (inspectionKey) {
	return (dispatch, getState) => {
		const s = getState()
		return fetch(
			window.INSP.config.apiUrl + `/api/inspection/activate/${inspectionKey}`,
			{
				method: "put",
				headers: { Authorization: "Bearer " + s.app.token }
			}
		)
	}
}

function handleErrors(response, dispatch) {
	if (!response.ok) 
		if (response.status == 401) {
			dispatch(openLoginBox());
		}
	
	return response;
}
